import AIOSpinner from '../../spinner/aio/AIO.js';
export default AIOSpinner;